import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { Button } from 'components/button'
import { DRAWER_KEY } from 'app-constants'
import './style.scss'

export function OsBlockWarning({ message }) {
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-os-block-warning'>
      <div className='container-info'>
        <STATICS.INFO_ERROR_FAQ />
        <span className='title'>Falha na sua região</span>
        <span className='message'>{message}</span>
      </div>
      <Button className='button' onClick={handleClick} color='primary'>
        ok, entendi
      </Button>
    </div>
  )
}
